<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<a id="pref_1">
</a>
<p class="img1">
<img alt="art" src="images/Art_Pvi.jpg"/>
</p>
<p class="pb">
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ItalianLover_pref_1.vue?4c926654